import { Controller } from '@hotwired/stimulus';
import 'chart.js/dist/chart.min';

export default class extends Controller {
  static targets = ['canvas'];

  static values = {
    chartType: String,
    labels: Array,
    data: Array,
    backgroundColor: Array,
    borderColor: Array,
    options: Object,
  };

  connect() {
    this.initChart();

    this.abortController = new AbortController();
    document.addEventListener('shown.bs.tab', (event) => {
      const tabId = event.target.getAttribute('href');
      const tab = document.querySelector(tabId);

      if (tab && tab.contains(this.element)) {
        this.initChart();
      }
    }, { signal: this.abortController.signal });
  }

  disconnect() {
    this.abortController.abort();

    const existingChart = Chart.getChart(this.canvasTarget);
    if (existingChart) {
      existingChart.destroy();
    }
  }

  initChart() {
    const existingChart = Chart.getChart(this.canvasTarget);
    if (existingChart) {
      existingChart.destroy();
    }

    const ctx = this.canvasTarget.getContext('2d');
    const chartType = this.chartTypeValue;

    const chartOptions = {
      type: chartType,
      data: {
        labels: this.labelsValue,
        datasets: [{
          label: this.optionsValue.label,
          data: this.dataValue,
          backgroundColor: this.backgroundColorValue,
          borderColor: this.borderColorValue,
          borderWidth: 1,
        }],
      },
      options: {
        plugins: {
          tooltip: {
            callbacks: {
              label: (tooltipItem) => {
                return chartType === 'pie' ? `${tooltipItem.raw} %` : tooltipItem.raw;
              },
            },
          },
          legend: {
            position: chartType === 'pie' ? 'right' : 'bottom',
            display: chartType !== 'bar',
          },
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    };

    if (chartType !== 'pie') {
      chartOptions.options.scales = {
        x: {
          title: { display: true, text: this.optionsValue.xLabel },
        },
        y: {
          title: { display: true, text: this.optionsValue.yLabel },
          beginAtZero: true,
        },
      };
    }

    new Chart(ctx, chartOptions);
  }
}
